import React from "react";
import { UnauthorizedPopupStoreImplementation } from "Data/UnauthorizedPopup/UnauthorizedPopupStoreImplementation";
import styles from "./Modals.module.css";
const UnauthorizedPopup: React.FC = () => {
  const { popupState, clearPopup } = UnauthorizedPopupStoreImplementation();

  if (!popupState.message) return null; // show only if we have a message

  return (
    <div className={styles.backdrop} data-testid="unauthorized-popup">
      <div className={styles.popup}>
        <h2 className={styles.title}>Action not allowed</h2>
        <p className={styles.message}>{popupState.message}</p>
        <button
          type="button"
          className={styles.button}
          onClick={clearPopup}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedPopup;
